import { FinanceProductScheduleProgressComponent } from './components/finance-product-schedule-progress/finance-product-schedule-progress.component';
import { FinanceProductScheduleFormatComponent } from './components/finance-product-schedule-format/finance-product-schedule-format.component';
import { PolicyScheduleUploadDto, ProductStatsStatusEnum, ProductStatsWrapperDto } from './../../../service/dto-insurance';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpInsuranceProductService } from '../../../service/http-insurance-product.service';
import { concatMap, EMPTY, finalize, interval, Subscription, switchMap, timer } from 'rxjs';
import { FileUploadDto, ResultListDto } from '../../../service/dto';
import { OnTableChange, TableColumn } from '../../../components/table/table.component';
import { HttpFileService } from '../../../service/http-file.service';
import { FormBuilder } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { HttpEventType } from '@angular/common/http';
import { FinanceProductCaptureDepositAmountComponent } from './components/finance-product-capture-deposit-amount/finance-product-capture-deposit-amount.component';

@Component({
	selector: 'app-finance-product-view',
	standalone: false,
	templateUrl: './finance-product-view.component.html',
	styleUrl: './finance-product-view.component.scss'
})
export class FinanceProductViewComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	wrapper?: ProductStatsWrapperDto;

	uploadedFile?: FileUploadDto;
	uploadProgress?: number;

	data?: ResultListDto<PolicyScheduleUploadDto>;
	pageIndex = 1;
	pageSize = 30;

	loading = false;
	columnRef: TableColumn[] = [

		{ "title": "ID", "property": "id" },
		{ "title": "Uploaded At", "cellRef": "refUploadedAt" },
		{ "title": "Agent", "cellRef": "refAgent" },
		{ "title": "Process Started At", "cellRef": "refProcessStartedAt" },
		{ "title": "Process Completed At", "cellRef": "refProcessCompletedAt" },
		{ "title": "Status", "cellRef": "refStatus" },
		{ "title": "Bank Deposit Amount", "cellRef": "refBankDepositAmount" },
		{ "title": "Premium Amount", "cellRef": "refTotalPremiumAmount" },

		{ "title": "Record Count", "cellRef": "refCountOfRecords" },
		{ "title": "Successful Records", "cellRef": "refCountOfValidRecords" },
		{ "title": "Failed Records", "cellRef": "refCountOfFailedRecords" },
		{ "title": "Invalid Records", "cellRef": "refCountOfInvalidRecords" },
		{ "title": "Removed Policies", "cellRef": "refRemovedPolicies" },
		{ "title": "Added Policies", "cellRef": "refAddedPolicies" },
		{ "title": "Updated Members", "cellRef": "refUpdatedPolicies" },
		{ "title": "Bank Balance Match", "cellRef": "refBankBalanceMatch" }
	];
	constructor(
		private route: ActivatedRoute,
		private fileService: HttpFileService,
		private httpService: HttpInsuranceProductService,
		private fb: FormBuilder,
		private router: Router,
		private modal: NzModalService) {
	}
	ngOnInit(): void {
		this.subscription.add(this.route.paramMap.subscribe(paramMap => {
			const id = paramMap.get('id')!;
			this.httpService.getWithStats(+id).subscribe(result => {
				this.wrapper = result;
				this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] });
			});
		}));
		this.subscription.add(interval(3000).subscribe(() => this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] })));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	getStatusColor(status: ProductStatsStatusEnum): string {
		switch (status) {
			case 'NeverRaised': return 'default';
			case 'ScheduleDue': return 'blue';
			case 'ScheduleOverdue': return 'red';
			case 'ScheduleUploaded': return 'green';
			default: return 'default';
		}
	}

	customUpload = (item: NzUploadXHRArgs): any => {
		this.uploadProgress = 0;

		const subscription = this.fileService.uploadWithProgress(item.name ?? 'bank-payment-received', item.file as any)
			.pipe(
				finalize(() => this.uploadProgress = undefined),
				switchMap((event) => {
					if (event.type === HttpEventType.UploadProgress) {
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgress = percentage === 100 ? 99 : percentage;
						return EMPTY;
					}

					if (event.type === HttpEventType.Response) {
						this.uploadProgress = 100;
						this.uploadedFile = event.body as FileUploadDto;

						const modal = this.modal.create({
							nzTitle: 'Enter Amount',
							nzContent: FinanceProductCaptureDepositAmountComponent,
							nzFooter: null
						});

						return modal.afterClose.pipe(
							switchMap((amount: number | null) => {
								if (amount == null) {
									return EMPTY;
								}
								return this.httpService.createAndValidateSchedule(
									this.wrapper!.product.id,
									amount,
									(event.body as FileUploadDto).uuid
								);
							})
						);
					}
					return EMPTY;
				})
			)
			.subscribe({
				next: (result) => {
					this.data?.list.push(result);
					this.modal.create({
						nzTitle: 'Status',
						nzContent: FinanceProductScheduleProgressComponent,
						nzFooter: null,
						nzWidth: 1024
					})
					.componentInstance!.scheduleId=result.id;
				},
				error: (err) => item.onError!(err, item.file!)
			});

		return { abort() { subscription.unsubscribe(); } };
	}
	doFetchUploads(input: OnTableChange) {
		this.pageIndex = input.pageIndex;
		this.pageSize = input.pageSize;
		this.loading = !this.data;

		this.httpService.getSchedules(this.wrapper!.product.id, this.pageIndex, this.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.data = result;
			});
	}
	doView(input: PolicyScheduleUploadDto) {
		// this.router.navigate(['schedule', input.id, 'view'], { relativeTo: this.route.parent });
		// this.router.navigate([input.id, 'view'], { relativeTo: this.route.parent });
	}

	openCsvFormatModal() {
		this.modal.create({
			nzTitle: 'CSV Format',
			nzContent: FinanceProductScheduleFormatComponent,
			nzFooter: null,
			nzWidth: 1024
		});
	}
}
